import { NavigateFunction, useNavigate } from "react-router-dom";
import Routes from "./helpers/Routes";
import Toast from "./helpers/Toast";
import { GetAssistanceDTO } from "./models/Assistance/GetAssistanceDTO";
import { AssistanceService } from "./services/AssistanceService";

class AssistanceUtilitiesClass {

    protected assistanceService = new AssistanceService();
    protected navigate?;

    constructor(navigate?: NavigateFunction) {
        this.navigate = navigate;
    }

    public GetAssistance = async (assistanceId?: string | null, docType?: string, serie?: string, number?: number) => {

        let assistance: GetAssistanceDTO | undefined;

        if (assistanceId) {
            const decodedId = decodeURIComponent(assistanceId);
            const parts = decodedId.split(" ");
            if (parts.length === 3) {
                assistance = {
                    docType: parts[0],
                    serie: parts[1],
                    number: Number(parts[2]),
                };
            } else {
                Toast.Show("error", "Formato da assistência inválido");
                return;
            }
        } else if (docType && serie && number !== undefined) {
            assistance = {
                docType: docType,
                serie: serie,
                number: number,
            };
        } else {
            Toast.Show("error", "Dados insuficientes");
            return;
        }

        const response = await this.assistanceService.GetAssistance(assistance);

        if (response.success === false || response.obj == null) {
            return;
        }

        return response.obj.id;
    };

    public NavigateToAssistanceDetails = async (assistanceId: number, preferedView: string | null, hasToReload?: boolean, newTab?: boolean) => {
        if (!this.navigate) {
            throw new Error("Navigate não está definido");
        }
        if (!preferedView) {
            throw new Error("Visão Preferida não está definida");
        }

        if (newTab) {
            if (preferedView?.toLocaleUpperCase() === "BACKOFFICE") {
                window.open(`${Routes.backoffice.details}/${assistanceId}`, "_blank");
            }
            else {
                window.open(`${Routes.oficina.details}/${assistanceId}`, "_blank");
            }
        }
        else {
            if (preferedView?.toLocaleUpperCase() === "BACKOFFICE") {
                this.navigate(`${Routes.backoffice.details}/${assistanceId}`);
            }
            else {
                this.navigate(`${Routes.oficina.details}/${assistanceId}`);
            }
        }

        if (hasToReload) {
            window.location.reload()
        }
    }

    public NavigateToAssistanceCreate = async (equipmentErpId: string | null | undefined, preferedView: string | null) => {
        if (!this.navigate) {
            throw new Error("Navigate não está definido");
        }
        if (!preferedView) {
            throw new Error("Visão Preferida não está definida");
        }
        if (preferedView?.toLocaleUpperCase() === "BACKOFFICE") {
            this.navigate(`${Routes.backoffice.create}/${equipmentErpId}`);
        }
        else {
            this.navigate(`${Routes.oficina.create}/${equipmentErpId}`);
        }
    }

    public IsValidAssistanceStatusForScheduling(status: string | null): boolean {
        if (!status) return false;
        const upperCaseStatus = status.toUpperCase();
        return upperCaseStatus === "ABERTURA" || upperCaseStatus === "EM CURSO" || upperCaseStatus === "ORÇAMENTO ACEITE";
    }

    public IsValidAssistanceStatusToChangeClientAndEquipment(status: string | null): boolean {
        if (!status) return false;
        const upperCaseStatus = status.toUpperCase();
        return upperCaseStatus === "ABERTURA" || upperCaseStatus === "EM CURSO";
    }
}

export const AssistanceUtilities = new AssistanceUtilitiesClass();

export const AssistanceUtilitiesWithNavigate = (navigate: NavigateFunction) => {
    return new AssistanceUtilitiesClass(navigate);
}



export const useNavigateToAssistanceCreate = () => {
    const navigate = useNavigate();

    return (clientErpId: string | null | undefined, clientName: string | null | undefined) => {
        navigate(Routes.backoffice.create, { state: { clientErpId, clientName } }); // state tem de ser usado, pq é uma prop da interface NavigateOptions
    };
};